import { permissionObj } from "../../../../../Helpers/permission"
import {DEFAULT_LATITUDE, DEFAULT_LONGITUDE} from "../../../../../Apis/functions";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import {SPECIAL_PERMISSION_TAB} from "../Manage/SpecialPermission/Model/Model";
import {DEDUCTION_POLICY_TAB} from "../Manage/DeductionPolicy/Model/Model";
import {IconEntryAdjustment, IconExitAdjustment} from "../../../../../components/buttons/IconButtons";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
export const NO_DEPARTMENT = "NO_DEPARTMENT";
export const SUFFIX_COLOR_TEXT = "Txt";
export const ASTERISK ="*";
//Tabs to show
export const TABS_ATTENDANCE = {
    ATTENDANCE: {
        INDEX: 0,
        TRANS: "attendance"
    },

    SUBMISSIONS: {
        INDEX: 1,
        TRANS: "submissions"
    },

    MANAGE: {
        INDEX: 2,
        TRANS: "manage"
    },
    OVERTIME_POLICIES: {
        INDEX: 3,
        TRANS: "payroll_policy"
    },
    PAYROLL: {
        INDEX: 4,
        TRANS: "payroll"
    },
};

export const ATTENDANCE_SUBVIEW_MODEL = {
    ATTENDANCE: {
        ATTENDANCE : 'attendance',
        MAP : 'map'
    },
    MANAGE: {
        SHIFT_ACCESS:"SHIFT_ACCESS",
        SETTINGS: "SETTINGS",
        SPECIAL_PERMISSION:"SPECIAL_PERMISSION",
        DEPARTMENT_POLICIES:"DEPARTMENT_POLICIES",
        GEOFENCE: "GEOFENCE",
        DEDUCTION_POLICY: "DEDUCTION_POLICY",
        DEDUCTION_POLICY_USER: "DEDUCTION_POLICY_USER"
    },
    SUBMISSIONS: {
        PERIOD_REVIEW:"PERIOD_REVIEW",
        REQUESTED: "REQUESTED",
        HISTORY:"HISTORY",
    },
    OVERTIME_POLICIES: {
        GLOBAL: "GLOBAL",
        BY_DEPARTMENT: "BY_DEPARTMENT",
    },
    PAYROLL: {
        ACTIVE: "ACTIVE",
        HISTORY: "HISTORY",
    }
}

const CREATE_PERMISSION_SUB_VIEW = {
    [ATTENDANCE_SUBVIEW_MODEL.MANAGE.SHIFT_ACCESS]: permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE,
    [ATTENDANCE_SUBVIEW_MODEL.MANAGE.GEOFENCE]: permissionObj?.WEB_ATTENDANCE_MANAGE_GEOFENCES_CREATE,
    [ATTENDANCE_SUBVIEW_MODEL.MANAGE.DEDUCTION_POLICY]: permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_CREATE,
    [ATTENDANCE_SUBVIEW_MODEL.MANAGE.DEDUCTION_POLICY_USER]: permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_USER_CREATE
};

export function TAB_PERMISSION_ATTENDANCE({ subView , view, subViewChild, exportReady = false }) {
    const isPayrollHistory = subView === ATTENDANCE_SUBVIEW_MODEL.PAYROLL.HISTORY;
    return {
        CREATE: {
            [TABS_ATTENDANCE.MANAGE.INDEX]: subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.DEDUCTION_POLICY
                ? (subViewChild === DEDUCTION_POLICY_TAB.USER.key
                    ? permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_USER_CREATE
                    : permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_CREATE)
                : CREATE_PERMISSION_SUB_VIEW[subView] || undefined,
            [TABS_ATTENDANCE.OVERTIME_POLICIES.INDEX]: permissionObj?.WEB_PAYROLL_POLICY_CREATE
        },
        UPDATE: {
            [TABS_ATTENDANCE.MANAGE.INDEX]: subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.SETTINGS
                ? permissionObj?.WEB_ATTENDANCE_SETTING_UPDATE
                : undefined,
            [TABS_ATTENDANCE.PAYROLL.INDEX]: isPayrollHistory
                ? undefined
                : permissionObj?.WEB_PAYROLL_ACTIVE_UPDATE,
        },
        ASSIGN: {
            [TABS_ATTENDANCE.MANAGE.INDEX]: subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.SPECIAL_PERMISSION &&
            subViewChild === SPECIAL_PERMISSION_TAB.ADD_EMPLOYEES.key ?
                    permissionObj?.WEB_USER_SPECIAL_PERMISSION_ASSIGN
                    : undefined
        },
        DELETE: {
            [TABS_ATTENDANCE.MANAGE.INDEX]:
                subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.SHIFT_ACCESS
                ? permissionObj?.WEB_ATTENDANCE_SHIFT_DELETE
                : subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.SPECIAL_PERMISSION && subViewChild === SPECIAL_PERMISSION_TAB.ASSIGNED_EMPLOYEES.key ?
                    permissionObj?.WEB_USER_SPECIAL_PERMISSION_DELETE
                : subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.DEDUCTION_POLICY && subViewChild === DEDUCTION_POLICY_TAB.USER.key ?
                    permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_USER_DELETE
                : undefined,
            [TABS_ATTENDANCE.OVERTIME_POLICIES.INDEX]: subView === ATTENDANCE_SUBVIEW_MODEL.OVERTIME_POLICIES.GLOBAL
                ? undefined
                : permissionObj?.WEB_PAYROLL_POLICY_DELETE
        },
        EXPORT : {
            [TABS_ATTENDANCE.ATTENDANCE.INDEX] : view === VIEW_TYPE.LIST.name ? permissionObj?.WEB_ATTENDANCE_EXPORT : undefined,
            [TABS_ATTENDANCE.PAYROLL.INDEX] : isPayrollHistory
                ? (exportReady ? permissionObj?.WEB_PAYROLL_HISTORY_EXPORT : undefined)
                : permissionObj?.WEB_PAYROLL_ACTIVE_EXPORT
        },
        ADVANCE_SEARCH : {
            [TABS_ATTENDANCE.ATTENDANCE.INDEX]: view === VIEW_TYPE.LIST.name ? permissionObj?.WEB_ATTENDANCE_READ : undefined
        },
        REVIEW_UPDATES : {
            [TABS_ATTENDANCE.SUBMISSIONS.INDEX]: subView === ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.PERIOD_REVIEW ?
                permissionObj?.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_MANAGE_ATTENDANCES :
                undefined
        },
        MODIFY_REQUESTS : {
            [TABS_ATTENDANCE.SUBMISSIONS.INDEX]: subView === ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.PERIOD_REVIEW ?
                permissionObj?.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_MANAGE_ATTENDANCES :
                undefined
        }
    }
}


export const MODEL_CONTEXT_ATTENDANCE = {
    tabIndex: null,
    disabledBtnDelete: true,
    modalCreate: false,
    modalDelete: false,
}


export const ATTENDANCE_MODEL ={
    departmentId :null ,
    userId :null ,
    latitude : DEFAULT_LATITUDE,
    longitude : DEFAULT_LONGITUDE,
    startDate: null,
    endDate: null,
}

export const SUB_VIEW_MODEL = {
    ATTENDANCE: {
        ATTENDANCE : 'attendance',
        MAP : 'map'
    },
    MANAGE :{
        MANAGE : 'manage'
    }
};

const getColorCss = (variableName) => {
    return getComputedStyle(document.documentElement)
        .getPropertyValue(variableName)
        .trim();
};

export const ATTENDANCE_COLOR_MODEL = {
    id:null,
    inTime: "",
    inTimeTxt: "",
    toleranceTime: "",
    toleranceTimeTxt: "",
    afterHours: "",
    afterHoursTxt: "",
    absent: "",
    absentTxt: "",
    noDepartment: "",
    noDepartmentTxt: "",
    specialPermission: "",
    specialPermissionTxt: "",
    offScheduleDeparture: "",
    offScheduleDepartureTxt: "",
    offScheduleArrival: "",
    offScheduleArrivalTxt: "",
    onVacations: "",
    onVacationsTxt: "",
    type : "ATTENDANCE_COLOR_MODEL",
    setDefaultData: function (){
        return {
            ...this,
            inTime: getColorCss("--in-time-color"),
            inTimeTxt: getColorCss("--in-time-text-color"),
            toleranceTime: getColorCss("--tolerance-time-color"),
            toleranceTimeTxt: getColorCss("--tolerance-time-text-color"),
            afterHours: getColorCss("--after-hours-color"),
            afterHoursTxt: getColorCss("--after-hours-text-color"),
            absent: getColorCss("--absent-color"),
            absentTxt: getColorCss("--absent-text-color"),
            noDepartment: getColorCss("--no-department-color"),
            noDepartmentTxt: getColorCss("--no-department-text-color"),
            specialPermission: getColorCss("--special-permission-color"),
            specialPermissionTxt: getColorCss("--special-permission-text-color"),
            offScheduleDeparture: getColorCss("--off-schedule-departure-color"),
            offScheduleDepartureTxt: getColorCss("--off-schedule-departure-text-color"),
            offScheduleArrival: getColorCss("--off-schedule-arrival-color"),
            offScheduleArrivalTxt: getColorCss("--off-schedule-arrival-text-color"),
            onVacations: getColorCss("--vacations-color"),
            onVacationsTxt: getColorCss("--vacations-text-color"),
        }
    },
    setData: function (item){
        return {
            ...this,
            ...item
        }
    },
    toRegister() {
        const { setData, toRegister, ...data } = this;
        return data;
    }
}

export const TYPE_MODEL_COLOR_MODEL = {
    BG_COLOR:"bg",
    TXT_COLOR:"txt"
}

export const ATTENDANCE_STATUS_MODEL = {
    absent: {
        id: 0,
        name: "absent",
        trans: "absent"
    },
    inTime: {
        id: 1,
        name: "inTime",
        trans: "in_time"
    },
    offScheduleDeparture: {
        id: 2,
        name: "offScheduleDeparture",
        trans: "off_schedule_departure"
    },
    afterHours: {
        id: 3,
        name: "afterHours",
        trans: "after_hours"
    },
    toleranceTime: {
        id: 4,
        name: "toleranceTime",
        trans: "tolerance_time"
    },
    noDepartment: {
        id: 5,
        name: "noDepartment",
        trans: "no_department"
    },
    specialPermission: {
        id: 6,
        name: "specialPermission",
        trans: "special_permission"
    },
    offScheduleArrival: {
        id: 7,
        name: "offScheduleArrival",
        trans: "off_schedule_arrival"
    },
    onVacations: {
        id: 8,
        name: "onVacations",
        trans: "on_vacations"
    },
    getById(id) {
        return Object.values(this).find(item => item?.id === id) || null;
    }
};

export const ATTENDANCE_STATUS_COLOR_MODEL = {
    [ATTENDANCE_STATUS_MODEL.absent.id]: 'absent',
    [ATTENDANCE_STATUS_MODEL.inTime.id]: 'inTime',
    [ATTENDANCE_STATUS_MODEL.offScheduleDeparture.id]: 'offScheduleDeparture',
    [ATTENDANCE_STATUS_MODEL.afterHours.id]: 'afterHours',
    [ATTENDANCE_STATUS_MODEL.toleranceTime.id]: 'toleranceTime',
    [ATTENDANCE_STATUS_MODEL.noDepartment.id]: 'noDepartment',
    [ATTENDANCE_STATUS_MODEL.specialPermission.id]: 'specialPermission',
    [ATTENDANCE_STATUS_MODEL.offScheduleArrival.id]: 'offScheduleArrival',
    [ATTENDANCE_STATUS_MODEL.onVacations.id]: 'onVacations'
}

// Icon of each adjusted bound. The status already tells the bound apart: an arrival
// carries offScheduleArrival and a departure offScheduleDeparture.
export const ADJUSTED_BOUND_ICON = {
    [ATTENDANCE_STATUS_MODEL.offScheduleArrival.id]: IconEntryAdjustment,
    [ATTENDANCE_STATUS_MODEL.offScheduleDeparture.id]: IconExitAdjustment
}

/**
 * Resolves the icon of a bound that no device captured.
 *
 * A bound without an access method comes from an adjustment, so it shows its own icon
 * instead of an access method one.
 *
 * @param {number|null} accessMethodId - Access method that captured the bound.
 * @param {number} dateStatus - Attendance status of the bound.
 * @returns {Function|null} Icon component, or null when the bound was captured.
 */
export const getAdjustedBoundIcon = (accessMethodId, dateStatus) => {
    if (accessMethodId != null) return null;

    return ADJUSTED_BOUND_ICON[dateStatus] || null;
}
